module.exports = __webpack_public_path__ + "static/media/koaffisch-bla.deed46b0.jpg";